var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 893,
    viewBox: "0 0 546 893",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.92 797.854H419.947V829.343C419.947 846.723 434.051 860.827 451.431 860.827C468.816 860.827 482.92 846.723 482.92 829.343V797.854Z",
    fill: "#01447A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.053 797.854H63.0801V829.343C63.0801 846.723 77.1841 860.827 94.5641 860.827C111.949 860.827 126.053 846.723 126.053 829.343V797.854Z",
    fill: "#01447A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.907 252.067V650.92C545.907 708.857 498.88 755.879 440.943 755.879H105.076C47.1387 755.879 0.112061 708.857 0.112061 650.92V252.067C0.112061 194.129 47.1387 147.103 105.076 147.103H440.943C498.88 147.103 545.907 194.129 545.907 252.067ZM252.013 315.04V587.933C252.013 599.522 261.42 608.928 273.003 608.928C284.591 608.928 293.997 599.522 293.997 587.933V315.04C293.997 303.451 284.591 294.051 273.003 294.051C261.419 294.051 252.013 303.452 252.013 315.04ZM84.08 315.04V587.933C84.08 599.522 93.4863 608.928 105.075 608.928C116.658 608.928 126.064 599.522 126.064 587.933V315.04C126.064 303.451 116.658 294.051 105.075 294.051C93.4862 294.051 84.08 303.452 84.08 315.04ZM419.96 315.04V587.933C419.96 599.522 429.361 608.928 440.949 608.928C452.538 608.928 461.944 599.522 461.944 587.933V315.04C461.944 303.451 452.538 294.051 440.949 294.051C429.361 294.051 419.96 303.452 419.96 315.04Z",
    fill: "#01447A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.973 21.1465C335.973 9.56319 326.567 0.157227 314.979 0.157227H231.009C219.426 0.157227 210.02 9.56346 210.02 21.1465V105.116H335.973V21.1465Z",
    fill: "#01447A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.d6cc6daf805707dc4b3e93fffb3a7a7b.svg";
export { ForwardRef as ReactComponent };